<template>
   <span v-if="pAnalysisLevel" :class="pacingClass">
     {{ 'dictionary.media.insertion.kpi.analysis.level.' + pAnalysisLevel | i18nText(pDictionary) }}
   </span>
</template>

<script>
import FormatMixin from "@/mixins/format-mixin";
import AnalysisLevelMixin from "@/components/common/metric/kpi/analysis-level-mixin";

export default {
  name: "MetricKpiInfoPacingAnalysis",
  mixins: [FormatMixin, AnalysisLevelMixin],
  props: {
    pDictionary: Object,
    pAnalysisLevel: String,
  },
  computed: {
    pacingClass: function () {
      return ['pacing-analysis', 'label', 'label-' + this.analysisLevelColor(this.pAnalysisLevel)];
    }
  }
}
</script>

<style scoped>

</style>